import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as jspreadsheet from 'jspreadsheet-ce';
import { ForecastYearEditable } from '../../services/forecast-year-editable.service';
import { CampaignUpdate } from './CampaignUpdate';

@Component({
	selector: 'app-forecast-year',
	templateUrl: './forecast-year.component.html',
	styleUrls: ['./forecast-year.component.scss'],
})
export class ForecastYearComponent implements AfterViewInit {
	@ViewChild('sheet', { static: true }) sheet: ElementRef;

	private campaingUpdate: CampaignUpdate = new CampaignUpdate(0, 0, 0, 0);

	constructor(private forecastYearEditable: ForecastYearEditable) {}

	ngAfterViewInit() {
		var promise = Promise.resolve(
			this.forecastYearEditable.getYearForecast(),
		);

		promise.then((val) => {
			var changed = (
				instance: any,
				cell: any,
				x: any,
				y: any,
				value: any,
			) => {
				var cellName = jspreadsheet.getColumnNameFromId([x, y]);
				var rowInt = parseInt(y) + 1;
				var row = 'A' + rowInt;
				var id = tableYear.getLabel(row);
				var growth = tableYear.getLabel('G' + rowInt);
				var nyl = tableYear.getLabel('H' + rowInt);
				var lyl = tableYear.getLabel('D' + rowInt);
				var lead_cost = tableYear.getLabel('L' + rowInt);
				var nyi = tableYear.getLabel('I' + rowInt);

				var getNyl = ((growth / 100 + 1) * lyl).toFixed(2);
				var getGrowth = ((nyl / lyl - 1) * 100).toFixed(2);

				var getNyi = (lead_cost * nyl).toFixed(2);

				if (lyl != 0) {
					if (x == 6 && nyl != getNyl) {
						tableYear.setValue('H' + rowInt, getNyl, true);
					}

					if (x == 7 && growth != getGrowth) {
						tableYear.setValue('G' + rowInt, getGrowth, true);
					}
				}

				if (x == 11) {
					this.campaingUpdate = new CampaignUpdate(
						id,
						growth,
						nyl,
						lead_cost,
					);
					Promise.resolve(
						this.forecastYearEditable.updateYearForecast(
							this.campaingUpdate,
						),
					);
				}

				this.campaingUpdate = new CampaignUpdate(
					id,
					growth,
					nyl,
					lead_cost,
				);
				Promise.resolve(
					this.forecastYearEditable.updateYearForecast(
						this.campaingUpdate,
					),
				);
			};

			var tableYear = jspreadsheet(this.sheet.nativeElement, {
				data: val.body,
				csvHeaders: true,
				search: true,
				pagination: 100,
				freezeColumns: 3,
				columns: [
					{ title: 'DB ID', width: 100, type: 'hidden' },
					{ title: 'Campaign ID', width: 80, readOnly: true },
					{ title: 'Campaign', width: 100, readOnly: true },
					{
						title: 'Last year leads',
						width: 100,
						mask: '#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Last year income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Represents Vs Total',
						width: 100,
						mask: '#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Growth',
						width: 100,
						mask: '#,##.00',
						decimal: '.',
					},
					{
						title: 'Next year leads',
						width: 100,
						mask: '#,##.00',
						decimal: '.',
					},
					{
						title: 'Next year income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Diference leads',
						width: 100,
						mask: '#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{
						title: 'Diference income',
						width: 100,
						mask: '$#,##.00',
						decimal: '.',
						readOnly: true,
					},
					{ title: 'Lead Cost', width: 0 },
				],
				footers: [
					[
						'id',
						'Total',
						'',
						'=ROUND(SUM(D1:D3000),2)',
						'=ROUND(SUM(E1:E3000),2)',
						'=ROUND(SUM(F1:F3000),2)',
						'=ROUND(AVERAGE(G1:G3000),2)',
						'=ROUND(SUM(H1:H3000),2)',
						'=ROUND(SUM(I1:I3000),2)',
						'=ROUND(SUM(J1:J3000),2)',
						'=ROUND(SUM(K1:K3000),2)',
					],
				],
				onchange: changed,
				updateTable: function (
					instance,
					cell,
					col,
					row,
					val,
					label,
					cellName,
				) {
					if (col == 6) {
						var growth = cell.innerText;
						if (growth > 0) {
							cell.style.backgroundColor = '#edfccf';
						}
					}

					if (col == 6) {
						var growth = cell.innerText;
						if (growth < 0) {
							cell.style.backgroundColor = '#f55742';
						}
					}

					if (col == 3) {
						var lastYearLeads = cell.innerText;
						if (lastYearLeads == 0) {
							cell.style.backgroundColor = '#fab60a';
						}
					}
				},
			});
		});
	}
}
